import { ESsPlayerBonusStage, ESsPlayerFreespinStage } from '~/types/softswiss/ssPlayerBonuses';
import { ESsPlayerPaymentStatus } from '~/types/softswiss/ssPlayerPayments';
import type { ISsPlayerBonuses, ISsPlayerFreespins } from '~/types/softswiss/ssPlayerBonuses';

export const shouldShowFreespinNotification = (notification: ISsPlayerFreespins) => {
  return (
    notification.stage === ESsPlayerFreespinStage.ISSUED ||
    notification.stage === ESsPlayerFreespinStage.ACTIVATED
  );
};

export const shouldShowBonusNotification = (notification: ISsPlayerBonuses) => {
  return (
    notification.stage === ESsPlayerBonusStage.ISSUED ||
    notification.stage === ESsPlayerBonusStage.HANDLE_BETS ||
    notification.stage === ESsPlayerBonusStage.WAIT
  );
};

export const shouldShowCashOutNotification = (status: ESsPlayerPaymentStatus) => {
  return status === ESsPlayerPaymentStatus.IN_PROGRESS || status === ESsPlayerPaymentStatus.SUCCESS;
};
